import { BaseEntityActions } from '../../../BaseEntity/BaseEntityActions';
import { EntityAction } from '../../../BaseEntity/EntityAction';
import { EEntityType } from '../../../../../Domain/Enum/EEntityType';
import { IActionPayloaded } from '../../../../../Infrastructure/Action/IAction';
import { DRIVER_All_VEHICLES_LOADED } from '../../../../../Constants/AppConstants';
import { VehicleTableDTO } from '../../../../../Domain/DTO/VehicleTableDTO';
import { ESortDir } from '../../../../../Domain/Enum/ESortDir';

export class SelectVehicleActions extends EntityAction {

    public LoadAllVehicles(
        text: string
    ){
        return super.LoadDataTable<VehicleTableDTO>(
            EEntityType.Vehicle,
            x => x.Name,
            ESortDir.Asc,
            undefined,
            text,
            this.AllVehiclesLoaded);
    }

    private AllVehiclesLoaded(value: Array<VehicleTableDTO>): IActionPayloaded<Array<VehicleTableDTO>> {
        return { type: DRIVER_All_VEHICLES_LOADED, Payload: value };
    }
}